var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("insect-positions-canvas", {
    ref: "canvas",
    attrs: { src: _vm.imageSrc, detection: _vm.detection },
    on: {
      "contextmenu:save": function ($event) {
        return _vm.$emit("save", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }